module.exports = __webpack_public_path__ + "static/BrandonGrotesque-Regular-8e3e13056cb508211ce5fe13d4f637c8.ttf";